<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="CX331, CX431, MC3224, MC3326, MC3426, XC2326 MFP'er">
     CX331, CX431, MC3224, MC3326, MC3426, XC2326 MFP'er
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_da" title="Sikkerhedsoplysninger">
     Sikkerhedsoplysninger
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Konventioner">
      Konventioner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e42" title="Produkterkl&aelig;ringer">
      Produkterkl&aelig;ringer
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_da" title="F&aring; oplysninger om printeren">
     F&aring; oplysninger om printeren
    </a>
   </p>
   <div id="divd0e177">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_da" title="S&aring;dan finder du oplysninger om printeren">
      S&aring;dan finder du oplysninger om printeren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_da" title="S&aring;dan finder du printerens serienummer">
      S&aring;dan finder du printerens serienummer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_da" title="Printerkonfigurationer">
      Printerkonfigurationer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_da" title="Brug af kontrolpanelet">
      Brug af kontrolpanelet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="customizing-home-screen-topic.html#customizing-home-screen_da" title="Tilpasning af startsk&aelig;rmen">
      Tilpasning af startsk&aelig;rmen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-language-of-keyboard-on-display-topic.html#changing-language-of-keyboard-on-display_da" title="&AElig;ndring af sproget for tastaturet p&aring; displayet">
      &AElig;ndring af sproget for tastaturet p&aring; displayet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_da" title="Beskrivelse af indikatorens status">
      Beskrivelse af indikatorens status
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e600" title="Valg af papir">
      Valg af papir
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_da" title="Ops&aelig;tning, installation og konfiguration">
     Ops&aelig;tning, installation og konfiguration
    </a>
   </p>
   <div id="divd0e1461">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_da" title="Valg af en placering til printeren">
      Valg af en placering til printeren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_da" title="Tilslutning af kabler">
      Tilslutning af kabler
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-trays-topic.html#installing-optional-trays_da" title="Installation af valgfrie papirmagasiner">
      Installation af valgfrie papirmagasiner
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-cloud-connector-profile-topic.html#d0e1674" title="Ops&aelig;tning og brug af startsk&aelig;rmsprogrammer">
      Ops&aelig;tning og brug af startsk&aelig;rmsprogrammer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e1799" title="Ops&aelig;tning af printeren til faxning">
      Ops&aelig;tning af printeren til faxning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_da" title="Konfiguration af e-mail SMTP-indstillinger">
      Konfiguration af e-mail SMTP-indstillinger
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-paper-size-and-type-topic.html#d0e3819" title="Il&aelig;gning af papir og specialmedier">
      Il&aelig;gning af papir og specialmedier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e3988" title="Installation og opdatering af software, drivere og firmware">
      Installation og opdatering af software, drivere og firmware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="available-options-topic.html#available-options_da" title="Tilg&aelig;ngelige muligheder">
      Tilg&aelig;ngelige muligheder
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-wireless-front-solutions-module-topic.html#d0e4280" title="Netv&aelig;rkstilslutning">
      Netv&aelig;rkstilslutning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_da" title="Udskrivning af siden med menuindstillinger">
      Udskrivning af siden med menuindstillinger
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_da" title="Sikring af printeren">
     Sikring af printeren
    </a>
   </p>
   <div id="divd0e4694">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_da" title="Sletning af printerhukommelse">
      Sletning af printerhukommelse
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_da" title="Gendannelse af fabriksindstillinger">
      Gendannelse af fabriksindstillinger
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_da" title="Erkl&aelig;ring om flygtighed">
      Erkl&aelig;ring om flygtighed
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_da" title="Udskrivning">
     Udskrivning
    </a>
   </p>
   <div id="divd0e4817">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_da" title="Udskrivning fra en computer">
      Udskrivning fra en computer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e4843" title="Udskrive fra en mobil enhed">
      Udskrive fra en mobil enhed
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_da" title="Udskrivning fra et flashdrev">
      Udskrivning fra et flashdrev
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_da" title="Underst&oslash;ttede flashdrev og filtyper">
      Underst&oslash;ttede flashdrev og filtyper
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_da" title="Konfiguration af fortrolige job">
      Konfiguration af fortrolige job
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_da" title="Udskrive fortrolige og andre tilbageholdte job">
      Udskrive fortrolige og andre tilbageholdte job
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-cloud-connector-profile-topic.html#printing-from-cloud-connector-profile_da" title="Udskrivning fra en Cloud Connector-profil">
      Udskrivning fra en Cloud Connector-profil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_da" title="Udskrivning af skrifttypeeksempler">
      Udskrivning af skrifttypeeksempler
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_da" title="Placering af skillesider mellem kopier">
      Placering af skillesider mellem kopier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_da" title="Annullering af et udskriftsjob">
      Annullering af et udskriftsjob
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_da" title="justere tonersv&aelig;rtningsgrad">
      justere tonersv&aelig;rtningsgrad
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_da" title="Kopiering">
     Kopiering
    </a>
   </p>
   <div id="divd0e5458">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_da" title="Ved hj&aelig;lp af den automatiske dokumentindf&oslash;ring og scannerens glasplade">
      Ved hj&aelig;lp af den automatiske dokumentindf&oslash;ring og scannerens glasplade
     </a>
    </p>
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_da" title="Kopiering">
      Kopiering
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_da" title="Kopiering af fotos">
      Kopiering af fotos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_da" title="Kopiering p&aring; brevpapir">
      Kopiering p&aring; brevpapir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_da" title="Kopiering p&aring; begge sider af papiret">
      Kopiering p&aring; begge sider af papiret
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-enlarging-copies-topic.html#reducing-enlarging-copies_da" title="Reducerer eller forst&oslash;rrer st&oslash;rrelsen af kopier">
      Reducerer eller forst&oslash;rrer st&oslash;rrelsen af kopier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="saving-paper-topic.html#saving-paper_da" title="Kopiering af flere sider til et enkelt ark">
      Kopiering af flere sider til et enkelt ark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_da" title="Sortering af kopier">
      Sortering af kopier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_da" title="Kopiere kort">
      Kopiere kort
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_da" title="Oprettelse af en kopigenvej">
      Oprettelse af en kopigenvej
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_da" title="E-mail">
     E-mail
    </a>
   </p>
   <div id="divd0e5744">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_da" title="Ved hj&aelig;lp af den automatiske dokumentindf&oslash;ring og scannerens glasplade">
      Ved hj&aelig;lp af den automatiske dokumentindf&oslash;ring og scannerens glasplade
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_da" title="Sender en e-mail">
      Sender en e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_da" title="Opret en e-mail genvej">
      Opret en e-mail genvej
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_da" title="Fax">
     Fax
    </a>
   </p>
   <div id="divd0e5862">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_da" title="Ved hj&aelig;lp af den automatiske dokumentindf&oslash;ring og scannerens glasplade">
      Ved hj&aelig;lp af den automatiske dokumentindf&oslash;ring og scannerens glasplade
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_da" title="Afsendelse af en fax">
      Afsendelse af en fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_da" title="Planl&aelig;gning af en fax">
      Planl&aelig;gning af en fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_da" title="Oprettelse af en faxdestinationsgenvej">
      Oprettelse af en faxdestinationsgenvej
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_da" title="&AElig;ndring af faxopl&oslash;sning">
      &AElig;ndring af faxopl&oslash;sning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_da" title="Justering af faxens m&oslash;rkhed">
      Justering af faxens m&oslash;rkhed
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_da" title="Udskriv en faxlog">
      Udskriv en faxlog
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_da" title="Blokering af junk-faxer">
      Blokering af junk-faxer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_da" title="Tilbageholdelse af faxer">
      Tilbageholdelse af faxer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_da" title="Videresendelse af en fax">
      Videresendelse af en fax
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_da" title="Scanning">
     Scanning
    </a>
   </p>
   <div id="divd0e6242">
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_da" title="Ved hj&aelig;lp af den automatiske dokumentindf&oslash;ring og scannerens glasplade">
      Ved hj&aelig;lp af den automatiske dokumentindf&oslash;ring og scannerens glasplade
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_da" title="Scanning til en computer">
      Scanning til en computer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-ftp-server-using-shortcut-topic.html#scanning-to-ftp-server-using-shortcut_da" title="Scanning til en FTP-server ved hj&aelig;lp af en genvej">
      Scanning til en FTP-server ved hj&aelig;lp af en genvej
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-network-folder-using-shortcut-topic.html#scanning-network-folder-using-shortcut_da" title="Scanning til en netv&aelig;rksmappe ved hj&aelig;lp af en genvej">
      Scanning til en netv&aelig;rksmappe ved hj&aelig;lp af en genvej
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_da" title="Scanning til et flashdrev">
      Scanning til et flashdrev
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-cloud-connector-profile-topic.html#scanning-to-cloud-connector-profile_da" title="Scanning til en Cloud Connector-profil">
      Scanning til en Cloud Connector-profil
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_da" title="Brug af printermenuer">
     Brug af printermenuer
    </a>
   </p>
   <div id="divd0e6576">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_da" title="Menuoversigt">
      Menuoversigt
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e6906" title="Enhed">
      Enhed
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e8911" title="Udskrivning">
      Udskrivning
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e9825" title="Papir">
      Papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e10138" title="Kopiering">
      Kopiering
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e10470" title="Fax">
      Fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e12088" title="E-mail">
      E-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e12771" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e13203" title="USB-drev">
      USB-drev
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e13822" title="Netv&aelig;rk/porte">
      Netv&aelig;rk/porte
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e15818" title="Sikkerhed">
      Sikkerhed
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-connector-menu-topic.html#cloud-connector-menu_da" title="Cloud Connector">
      Cloud Connector
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e16547" title="Rapporter">
      Rapporter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_da" title="Fejlfinding">
      Fejlfinding
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_da" title="Vedligeholdelse af printeren">
     Vedligeholdelse af printeren
    </a>
   </p>
   <div id="divd0e16855">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_da" title="Kontrol af status for dele og forbrugsstoffer">
      Kontrol af status for dele og forbrugsstoffer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_da" title="Konfiguration af meddelelser om forbrugsstoffer">
      Konfiguration af meddelelser om forbrugsstoffer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_da" title="Indstilling af e-mail-advarsler">
      Indstilling af e-mail-advarsler
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_da" title="Visning af rapporter">
      Visning af rapporter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-supplies-group.html#ordering-supplies-group_da" title="Bestilling af dele og forbrugsstoffer">
      Bestilling af dele og forbrugsstoffer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-print-cartridge-topic.html#d0e17633" title="Udskiftning af dele og forbrugsstoffer">
      Udskiftning af dele og forbrugsstoffer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e17882" title="Reng&oslash;ring af printerens dele">
      Reng&oslash;ring af printerens dele
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e18036" title="Spare energi og papir">
      Spare energi og papir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_da" title="Flytning af printeren til et andet sted">
      Flytning af printeren til et andet sted
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_da" title="Transport af printeren">
      Transport af printeren
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_da" title="Fejlfinding af et problem">
     Fejlfinding af et problem
    </a>
   </p>
   <div id="divd0e18193">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_da" title="Problemer med udskriftskvalitet">
      Problemer med udskriftskvalitet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_da" title="Udskrivningsproblemer">
      Udskrivningsproblemer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_da" title="Printeren reagerer ikke">
      Printeren reagerer ikke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_da" title="Det var ikke muligt at l&aelig;se flashdrevet">
      Det var ikke muligt at l&aelig;se flashdrevet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_da" title="Aktivering af USB-porten">
      Aktivering af USB-porten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e20762" title="Problemer med netv&aelig;rksforbindelsen">
      Problemer med netv&aelig;rksforbindelsen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e20974" title="Problemer med forbrugsstoffer">
      Problemer med forbrugsstoffer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_da" title="Fjerne papirstop">
      Fjerne papirstop
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e21449" title="Problemer med papirindf&oslash;ring">
      Problemer med papirindf&oslash;ring
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e21816" title="Problemer med e-mail">
      Problemer med e-mail
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e21912" title="Faxproblemer">
      Faxproblemer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e22550" title="Scanningsproblemer">
      Scanningsproblemer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e23328" title="Problemer med farvekvaliteten">
      Problemer med farvekvaliteten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_da" title="Kontakt til kundesupport">
      Kontakt til kundesupport
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_da" title="Genbrug og bortskaffelse">
     Genbrug og bortskaffelse
    </a>
   </p>
   <div id="divd0e23578">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_da" title="Genbrug af Lexmark-produkter">
      Genbrug af Lexmark-produkter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_da" title="Genbrug af Lexmark-emballage">
      Genbrug af Lexmark-emballage
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_da" title="Bekendtg&oslash;relser">
     Bekendtg&oslash;relser
    </a>
   </p>
   <div id="divd0e23613">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e23616" title="Produktinformation">
      Produktinformation
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e23633" title="Bekendtg&oslash;relse om version">
      Bekendtg&oslash;relse om version
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_da" title="Varem&aelig;rker">
      Varem&aelig;rker
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_da" title="Licensmeddelelser">
      Licensmeddelelser
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_da" title="St&oslash;jemissionsniveauer">
      St&oslash;jemissionsniveauer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_da" title="Direktiv om affald af elektrisk og elektronisk udstyr (WEEE)">
      Direktiv om affald af elektrisk og elektronisk udstyr (WEEE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e23739" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_da" title="Bortskaffelse af produktet">
      Bortskaffelse af produktet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e23773" title="Genopladeligt litium-ion-batteri">
      Genopladeligt litium-ion-batteri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_da" title="Regulering (EU) 2023/1542">
      Regulering (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_da" title="Returnering af Lexmark-tonerpatroner til genbrug eller genvinding">
      Returnering af Lexmark-tonerpatroner til genbrug eller genvinding
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_da" title="Meddelelse om statisk f&oslash;lsomhed">
      Meddelelse om statisk f&oslash;lsomhed
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_da" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_da" title="Temperaturoplysninger">
      Temperaturoplysninger
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_da" title="Lasererkl&aelig;ring">
      Lasererkl&aelig;ring
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_da" title="Str&oslash;mforbrug">
      Str&oslash;mforbrug
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_da" title="Lovgivningsm&aelig;ssige oplysninger for terminaludstyr inden for telekommunikation">
      Lovgivningsm&aelig;ssige oplysninger for terminaludstyr inden for telekommunikation
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e24041" title="Lovgivningsm&aelig;ssige oplysninger for tr&aring;dl&oslash;se produkter">
      Lovgivningsm&aelig;ssige oplysninger for tr&aring;dl&oslash;se produkter
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_da" title="Meddelelse om modulkomponent">
      Meddelelse om modulkomponent
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_da" title="Uds&aelig;ttelse for radiofrekvens">
      Uds&aelig;ttelse for radiofrekvens
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e24067" title="Overensstemmelse med Det Europ&aelig;iske F&aelig;llesskabs (EF) direktiver">
      Overensstemmelse med Det Europ&aelig;iske F&aelig;llesskabs (EF) direktiver
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-b_da" title="Overensstemmelse med Det Europ&aelig;iske F&aelig;llesskabs (EF) direktiver">
      Overensstemmelse med Det Europ&aelig;iske F&aelig;llesskabs (EF) direktiver
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue